module.exports = __webpack_public_path__ + "static/snowboarding-1-c5534fc82a2d167606faad36df2629f6.jpg";